<template>
    <!-- 关于我们 -->
    <div>
        <div class="swiper-slide" v-for="(value, index) in components" :key="index">
            <component :is="value" />
        </div>
        <!-- <div class="egg-container">
        <div class="swiper-container" ref="mySwiper">
            <div class="swiper-wrapper">
                
            </div>
            <div class="swiper-pagination" v-if="components.length"></div>
        </div>
    </div> -->
    </div>
</template>
<script>
// import Swiper from 'swiper';
import ContactUs from './ContactUs.vue';
import About from './About.vue';
import AboutOne from './AboutOne.vue';
import Cooperation from "./Cooperation.vue";
import CooperationOne from './CooperationOne.vue';
import License from './License.vue';
import LicenseOne from './LicenseOne.vue';
import AppFooter from '@/layout/AppFooter.vue';
export default {
    name: 'aboutAll',
    components: {
        ContactUs,
        About,
        AboutOne,
        Cooperation,
        CooperationOne,
        License,
        LicenseOne,
        AppFooter
    },
    data() {
        return {
            mySwiper: null,
            components: [
                'ContactUs',
                'About',
                'AboutOne',
                'Cooperation',
                'CooperationOne',
                'License',
                'LicenseOne',
                'AppFooter'
            ]
        };
    },
    mounted() {
        // this.initSwiper();
        // if (this.$route.params.id !== '0') {
        //     if (this.mySwiper) {
        //         this.mySwiper.slideTo(this.$route.params.id, 500); // 500为动画时长，可自定义
        //     }
        // }
    },
    beforeDestroy() {
        // if (this.mySwiper) {
        //     this.mySwiper.destroy();
        // }
    },
    methods: {
        initSwiper() {
            this.mySwiper = new Swiper(this.$refs.mySwiper, {
                direction: 'vertical',
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                speed: 500,
                mousewheel: true,
                simulateTouch: false,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                },
                on: {
                    slideChange: function () {
                        console.log('当前滑动到第' + (this.activeIndex + 1) + '屏');
                    },
                }
            });
        },
    },
}
</script>
<style scoped lang="scss">
.egg-container {
    width: 100%;
    height: var(--main-height);
    overflow: hidden;
}

.swiper-container {
    width: 100%;
    height: var(--main-height);
}

.swiper-slide {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // text-align: center;
    // font-size: 18px;
    // background: #fff;
    // color: #fff;
    position: relative;
}


/* 分页器样式 */
.swiper-pagination {
    width: 20px;
    overflow: hidden;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;

    ::v-deep .swiper-pagination-bullet {
        width: 20px;
        height: 5px;
        border-radius: 10px;
    }
}

// .swiper-pagination-bullet {
//     width: 30px;
//     height: 12px;
//     background: rgba(255, 255, 255, 0.5);
//     margin: 8px 0;
//     border-radius: 50%;
//     cursor: pointer;
//     transition: all 0.3s ease;
// }

// .swiper-pagination-bullet-active {
//     background: #fff;
//     transform: scale(1.3);
// }

</style>